import { pageTitleStyles } from "@dana/Overrides/Widgets/ProductDetails/ProductDetailsPageTitle";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { css } from "styled-components";
import { themeColors } from "@dana/MobiusOverrides/styles/colors";

pageTitleStyles.brandGridItem = mergeToNew(pageTitleStyles.brandGridItem, {
    css: css`
        flex-basis: 40px;
        max-width: 40px;
        flex-shrink: 0 !important;
        padding: 0;
        max-height: 40px;
    `,
});

pageTitleStyles.badgeGridItem = mergeToNew(pageTitleStyles.badgeGridItem, {
    css: css`
        flex-basis: 200px;
        max-width: 200px;
        flex-shrink: 0 !important;
        padding: 0;
        max-height: 40px;
    `,
});

pageTitleStyles.badgeRed = mergeToNew(pageTitleStyles.badgeRed, {
    as: "p",
    size: fontSizes.medium,
    lineHeight: lineHeights.medium,
    color: themeColors.danger,
    css: css`
        border: 1px solid ${themeColors.danger};
        width: fit-content;
        padding: 2px 5px;
        margin-top: 4px;
    `,
});